export const colors = {
  primary: {
    main: '#591977',
    light: '#6182FE',
    dark: '#591977',
  },
  secondary: {
    main: '#EB7D14',
    light: '#EF7D12',
    dark: '#EB7D14',
  },
  gradients: {
    primary: 'linear-gradient(135deg, #591977 0%, #6182FE 100%)',
    secondary: 'linear-gradient(135deg, #EB7D14 0%, #EF7D12 100%)',
    primaryLight: 'linear-gradient(135deg, #6182FE 0%, #591977 100%)',
    secondaryLight: 'linear-gradient(135deg, #EF7D12 0%, #EB7D14 100%)',
  },
  text: {
    primary: '#333333',
    secondary: '#4A5568',
    light: '#FFFFFF',
  },
  background: {
    primary: '#FFFFFF',
    secondary: '#F8FAFF',
    dark: '#1A1A1A',
  },
  shadow: {
    primary: 'rgba(67, 149, 202, 0.2)',
    secondary: 'rgba(235, 125, 20, 0.2)',
  }
}; 